import ThumbListContainer from './ThumbListContainer';

export default ThumbListContainer;
